import s, { useMemo as b, forwardRef as h } from "react";
import * as l from "react-aria-components";
import c from "@appchoose/cn";
const L = ({
  ...e
}) => (
  // allowsEmptyCollection is needed to prevent the no results message from showing
  /* @__PURE__ */ s.createElement(l.ComboBox, { allowsEmptyCollection: !0, ...e })
), y = s.forwardRef(({ className: e, disabled: t, ...r }, o) => /* @__PURE__ */ s.createElement(
  l.Input,
  {
    ref: o,
    className: c(
      "form-input block w-full rounded border p-2 text-sm leading-5.5 outline-none",
      {
        "text-gray-900 placeholder-gray-500 transition duration-300": !t,
        "cursor-not-allowed border-gray-100 bg-gray-50 text-gray-500 placeholder-gray-300": t,
        'border-gray-500 hover:border-gray-700 focus:border-gray-700 focus:ring-gray-700 aria-[invalid="true"]:border-red-600 aria-[invalid="true"]:ring-red-600': !t
      },
      e
    ),
    disabled: t,
    ...r
  }
));
y.displayName = "ComboboxInput";
const S = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s.createElement(
  l.Popover,
  {
    className: c(
      "z-10 w-[--trigger-width] overflow-auto rounded-md border bg-white p-1 shadow-lg",
      e
    ),
    ...t
  }
), $ = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s.createElement(l.ListBox, { className: e, ...t }), A = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s.createElement(
  l.ListBoxItem,
  {
    className: c(
      "flex cursor-pointer items-center whitespace-pre rounded-sm p-2 text-sm text-gray-700 data-[focused=true]:bg-green-300 data-[hovered=true]:bg-green-300 data-[hovered=true]:text-gray-900",
      e
    ),
    ...t
  }
), P = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s.createElement(l.ListBoxSection, { className: e, ...t }), F = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s.createElement(
  l.Header,
  {
    className: c(
      "px-2 py-1 text-xs font-semibold uppercase tracking-wider text-gray-700",
      e
    ),
    ...t
  }
), M = ({
  className: e,
  ...t
}) => /* @__PURE__ */ s.createElement(
  "div",
  {
    className: c("flex items-center p-2 text-sm text-gray-900", e),
    ...t
  }
);
function w({
  autoEscape: e,
  caseSensitive: t = !1,
  findChunks: r = p,
  sanitize: o,
  searchWords: n,
  textToHighlight: a
}) {
  return x({
    chunksToHighlight: g({
      chunks: r({
        autoEscape: e,
        caseSensitive: t,
        sanitize: o,
        searchWords: n,
        textToHighlight: a
      })
    }),
    totalLength: a ? a.length : 0
  });
}
function g({ chunks: e }) {
  return e.sort((t, r) => t.start - r.start).reduce((t, r) => {
    if (t.length === 0)
      return [r];
    {
      const o = t.pop();
      if (r.start <= o.end) {
        const n = Math.max(o.end, r.end);
        t.push({
          highlight: !1,
          start: o.start,
          end: n
        });
      } else
        t.push(o, r);
      return t;
    }
  }, []);
}
function p({
  autoEscape: e,
  caseSensitive: t,
  sanitize: r = E,
  searchWords: o,
  textToHighlight: n
}) {
  return n = r(n ?? ""), o.filter((a) => a).reduce((a, i) => {
    i = r(i), e && (i = v(i));
    const d = new RegExp(i, t ? "g" : "gi");
    let u;
    for (; u = d.exec(n ?? ""); ) {
      const m = u.index, f = d.lastIndex;
      f > m && a.push({ highlight: !1, start: m, end: f }), u.index === d.lastIndex && d.lastIndex++;
    }
    return a;
  }, []);
}
function x({
  chunksToHighlight: e,
  totalLength: t
}) {
  const r = [];
  if (e.length === 0)
    o(0, t, !1);
  else {
    let n = 0;
    e.forEach((a) => {
      o(n, a.start, !1), o(a.start, a.end, !0), n = a.end;
    }), o(n, t, !1);
  }
  return r;
  function o(n, a, i) {
    a - n > 0 && r.push({
      start: n,
      end: a,
      highlight: i
    });
  }
}
function E(e) {
  return e;
}
function v(e) {
  return e.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}
function I(e) {
  return String(e).replace(/([.*+?=^!:${}()|[\]/\\])/g, "\\$1");
}
const C = {
  combineChunks: g,
  fillInChunks: x,
  findAll: w,
  findChunks: p
}, z = ({
  value: e,
  textToHighlight: t,
  ...r
}) => {
  const o = b(
    () => C.findAll({
      searchWords: I(t || "").split(/\s+/),
      textToHighlight: e
    }),
    [t, e]
  );
  return o.length ? o.map((n, a) => {
    const i = e.slice(n.start, n.end);
    return /* @__PURE__ */ s.createElement(
      "span",
      {
        key: a,
        "data-user-value": n.highlight ? !0 : void 0,
        "data-suggested-value": n.highlight ? void 0 : !0,
        ...r
      },
      i
    );
  }) : e;
}, N = h(({ className: e, ...t }, r) => /* @__PURE__ */ s.createElement(
  "div",
  {
    className: c(
      "relative w-full text-gray-500 transition-colors focus-within:text-gray-900",
      e
    ),
    ref: r,
    ...t
  }
));
N.displayName = "InputContainer";
export {
  L as Combobox,
  M as ComboboxEmpty,
  F as ComboboxHeader,
  y as ComboboxInput,
  A as ComboboxItem,
  $ as ComboboxList,
  S as ComboboxPopover,
  P as ComboboxSection,
  z as HighlightText,
  N as InputContainer,
  L as default
};
